/** ドメイン名の表示用ラベルマップ */
export const DOMAIN_LABELS: Record<string, string> = {
  monsnode: 'Monsnode',
  x: 'X',
  zozo: 'ZOZO',
  miss: 'MISS',
  nh: 'NH',
  line: 'LINE',
  tver: 'TVer',
  fod: 'FOD',
  abema: 'ABEMA',
  oreilly: "O'Reilly",
  archive: 'Archive',
  local: 'Local',
  private: 'Private',
  audiobook: 'Audiobook',
  apple_music: 'Apple Music',
  english: 'English',
  jcom: 'J:COM',
  jump: 'Jump+',
  piccoma: 'ピッコマ',
  kadokomi: 'カドコミ',
  eufy: 'Eufy',
  garmin: 'Garmin',
  netflix: 'Netflix',
  unext: 'U-NEXT',
}

/** ドメイン名を表示用ラベルに変換する */
export const getDomainLabel = (domain: string) => DOMAIN_LABELS[domain] ?? domain
